import {Component, OnInit} from '@angular/core';
import { LayoutService } from '../../user-area-layout.service';

@Component({
  selector: 'mcb-portal-user-area-header',
  templateUrl: './header.component.html'
})
export class PortalUserAreaHeaderComponent implements OnInit {

  public showSidebarClass = '';

  constructor(private layoutService: LayoutService) {
  }

  ngOnInit() {
    this.layoutService.onSideBarToggle.subscribe(showSidebar => {
      if (!showSidebar) {
        this.showSidebarClass = 'mcb-sidebar-hide';
      } else {
        this.showSidebarClass = '';
      }
    });
  }

  onHeaderToggleClick() {
    this.layoutService.openSideBar();
  }


}
